import {SessionService} from './session.service';

export const MOBILE_PLANNING_ME_URL = '/pages/planning/me';
export const MOBILE_PLANNING_WEEK_URL = '/pages/planning/courant';

export function hasMobileWeekPlanningAccess(session: SessionService): boolean {
	return session.hasPermission('planning') || session.hasPermission('planning_view');
}

export function hasMobileOwnPlanningAccess(session: SessionService): boolean {
	return session.hasPermission('mon_planning');
}

/** Route planning par défaut sur mobile : semaine si manager, sinon mon planning. */
export function getMobilePlanningUrl(session: SessionService): string {
	if (hasMobileWeekPlanningAccess(session)) {
		return MOBILE_PLANNING_WEEK_URL;
	}
	return MOBILE_PLANNING_ME_URL;
}

export function isMobilePlanningPathAllowed(url: string, session: SessionService): boolean {
	const path = url.split('?')[0].split('#')[0];

	if (path.startsWith('/pages/planning/courant') || path === '/pages/planning') {
		return hasMobileWeekPlanningAccess(session);
	}

	if (path.startsWith('/pages/planning/template')) {
		return session.hasPermission('planning');
	}

	if (path.startsWith('/pages/planning/me')) {
		return hasMobileOwnPlanningAccess(session);
	}

	if (path.startsWith('/pages/planning')) {
		return hasMobileWeekPlanningAccess(session) || hasMobileOwnPlanningAccess(session);
	}

	return true;
}
